import { OfferFilter, OfferFlag, OfferOrderBy } from '@obeta/schema'
import { QueryParams } from '../VirtualizedList'

export type OfferDisplayViewType = Extract<OfferFilter, 'isFavorite'> | 'all'
export type OfferFlagViewType = OfferFlag | 'all'

export type OfferListFilters = {
  display: OfferDisplayViewType
  flag: OfferFlagViewType
  searchTerm: string
  orderBy: OfferOrderBy
}

export type OfferListURLSearchParams = {
  display?: string
  flag?: string
  searchTerm?: string
  orderBy?: string
}

export const DEFAULT_OFFER_LIST_FILTERS: OfferListFilters = {
  display: 'all',
  flag: 'all',
  searchTerm: '',
  orderBy: 'startDate',
}

export const DEFAULT_OFFER_LIST_QUERY_PARAMS: QueryParams = {
  limit: '24',
  offset: '0',
}
